import { Injectable, HostListener, Inject } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';
import { WINDOW } from "./windows.service";
// Menu
export interface Menu {
	path?: string;
	title?: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	active?: boolean;
	bookmark?: boolean;
	children?: Menu[];
}

@Injectable({
	providedIn: 'root'
})

export class NavService {

	public screenWidth: any
	public collapseSidebar: boolean = false

	constructor(@Inject(WINDOW) private window) {
		this.onResize();
		if (this.screenWidth < 991) {
			this.collapseSidebar = true
		}
	}

	// Windows width
	@HostListener("window:resize", ['$event'])
	onResize(event?) {
		this.screenWidth = window.innerWidth;
	}

	MENUITEMS: Menu[] = [
		{
			path: '/adminhkbkcms/dashboard/default', title: 'Dashboard', icon: 'home', type: 'link', badgeType: 'primary', active: false
		},
		{
			title: 'Media', path: '/adminhkbkcms/media', icon: 'camera', type: 'link', active: false
		},
		{
			title: 'Other Files Path', path: '/adminhkbkcms/filespath', icon: 'file', type: 'link', active: false
		},
		/* {
			title: 'Our Institutions', icon: 'box', type: 'sub', active: false, children: [
				// { path: '/adminhkbkcms/engineeringpage/', title: 'Engineering', type: 'link' },
				{
					title: 'Institutions Information', type: 'sub', children: [
						{ path: '/adminhkbkcms/institutions/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/institutions/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Institutions Details', type: 'sub', children: [
						{ path: '/adminhkbkcms/institutions-info/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/institutions-info/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Institutions Slider', type: 'sub', children: [
						{ path: '/adminhkbkcms/institutionsslider/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/institutionsslider/create-page', title: 'Create Page', type: 'link' },
					]
				},
				 {
					title: 'Advanced Engineering', type: 'sub', children: [
						{ path: '/adminhkbkcms/advancedengineering/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/advancedengineering/create-page', title: 'Create Page', type: 'link' },
					]
				}, 
			]
		}, */
		{
			title: 'Master', icon: 'align-left', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/testimonials/', title: 'Testimonials', type: 'link' },				
				{
					title: 'Pages', icon: 'clipboard', type: 'sub', active: false, children: [
						{ path: '/adminhkbkcms/pages/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/pages/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Sections', icon: 'clipboard', type: 'sub', active: false, children: [
						{ path: '/adminhkbkcms/sections/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/sections/create-page', title: 'Create Page', type: 'link' },
					]
				},
				/* {
					title: 'Placements News', icon: 'clipboard', type: 'sub', active: false, children: [
						{ path: '/adminhkbkcms/placementsnews/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/placementsnews/create-page', title: 'Create Page', type: 'link' },
					]
				}, 
				{
					title: 'Student Stories', type: 'sub', children: [
						{ path: '/adminhkbkcms/studentstories/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/studentstories/create-page', title: 'Create Page', type: 'link' },
					]
				},*/
				{
					title: 'News Year', icon: 'clipboard', type: 'sub', active: false, children: [
						{ path: '/adminhkbkcms/news-year/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/news-year/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'News Categories', icon: 'clipboard', type: 'sub', active: false, children: [
						{ path: '/adminhkbkcms/news-categories/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/news-categories/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'News', icon: 'clipboard', type: 'sub', active: false, children: [
						{ path: '/adminhkbkcms/news/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/news/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Footer', icon: 'clipboard', type: 'sub', active: false, children: [
						{ path: '/adminhkbkcms/footer/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/footer/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Blogs', icon: 'clipboard', type: 'sub', active: false, children: [
						{ path: '/adminhkbkcms/blogs/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/blogs/create-page', title: 'Create Page', type: 'link' },
					]
				},
				/* { path: '/adminhkbkcms/human-resources/', title: 'Human Resources', type: 'link' },
				 */{
					title: 'Tech Venture Sliders', icon: 'clipboard', type: 'sub', active: false, children: [
						{ path: '/adminhkbkcms/clubs/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/clubs/create-page', title: 'Create Page', type: 'link' },
					]
				},
				/* {
					title: 'Seo Course Pages', icon: 'clipboard', type: 'sub', active: false, children: [
						{ path: '/adminhkbkcms/seo-cource-page/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/seo-cource-page/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Seo Cours Page Faq', icon: 'clipboard', type: 'sub', active: false, children: [
						{ path: '/adminhkbkcms/seo-course-page-faq/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/seo-course-page-faq/create-page', title: 'Create Page', type: 'link' },
					]
				}, */
			]
		},
		{
			title: 'Courses', icon: 'box', type: 'sub', active: false, children: [
				{
					title: 'Add Course', icon: 'users', type: 'sub', active: false, children: [
						{ path: '/adminhkbkcms/course/list-page', title: 'Courses List', type: 'link' },
						{ path: '/adminhkbkcms/course/create-page', title: 'Create Course', type: 'link' },
					]
					/*title: 'Physical', type: 'sub', children: [
						{ path: '/adminhkbkcms/products/physical/category', title: 'Category', type: 'link' },
						{ path: '/adminhkbkcms/products/physical/sub-category', title: 'Sub Category', type: 'link' },
						{ path: '/adminhkbkcms/products/physical/product-list', title: 'Product List', type: 'link' },
						{ path: '/adminhkbkcms/products/physical/product-detail', title: 'Product Detail', type: 'link' },
						{ path: '/adminhkbkcms/products/physical/add-product', title: 'Add Product', type: 'link' },
					]*/
				},
				{
					title: 'Fees and Scholarship', type: 'sub', children: [
						{ path: '/adminhkbkcms/fees/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/fees/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Overview', type: 'sub', children: [
						{ path: '/adminhkbkcms/overview/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/overview/create-page', title: 'Create Page', type: 'link' },
						
					]

				},
				{
					title: 'Programs', type: 'sub', children: [
						{ path: '/adminhkbkcms/programs/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/programs/create-page', title: 'Create Page', type: 'link' },
						
					]

				},
				{
					title: 'Beyond', type: 'sub', children: [
						{ path: '/adminhkbkcms/beyond/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/beyond/create-page', title: 'Create Page', type: 'link' },
						
					]

				},
				{
					title: 'Future', type: 'sub', children: [
						{ path: '/adminhkbkcms/future/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/future/create-page', title: 'Create Page', type: 'link' },
						
					]

				},
				
				
				
				{
					title: 'Fee', type: 'sub', children: [
						{ path: '/adminhkbkcms/fee/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/fee/create-page', title: 'Create Page', type: 'link' },
						
					]

				},
				{
					title: 'Curriculum', type: 'sub', children: [
						{ path: '/adminhkbkcms/curriculum/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/curriculum/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Eligibility', type: 'sub', children: [
						{ path: '/adminhkbkcms/eligibility/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/eligibility/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Moredetails', type: 'sub', children: [
						{ path: '/adminhkbkcms/moredetails/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/moredetails/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Recruiters', type: 'sub', children: [
						{ path: '/adminhkbkcms/recruiters/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/recruiters/create-page', title: 'Create Page', type: 'link' },
					]
				},
				/*  */
				
			]
		},
		{
			title: 'Home', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/homecontents/', title: 'Home Contents', type: 'link' },
				{ path: '/adminhkbkcms/aboutbrowseby/', title: 'About Browse By', type: 'link' },
				{
					title: 'Home Rank Section', type: 'sub', children: [
						{ path: '/adminhkbkcms/homeranksection/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/homeranksection/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Home Slider', type: 'sub', children: [
						{ path: '/adminhkbkcms/homeslider/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/homeslider/create-page', title: 'Create Page', type: 'link' },
					]
				},
			]
		},
		{
			title: 'Life@Oneb', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/lifehkbkoverview', title: 'Life@Onesb Overview', type: 'link' },
				{
					title: 'Campus life Slider', type: 'sub', children: [
						{ path: '/adminhkbkcms/getmore/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/getmore/create-page', title: 'Create Page', type: 'link' },
					]
				},
				/* { path: '/adminhkbkcms/nss/', title: 'Nss', type: 'link' },
				{ path: '/adminhkbkcms/sports-adventure/', title: 'Sports Adventure', type: 'link' },
				 */{
					title: 'Campus life Facts', type: 'sub', children: [
						{ path: '/adminhkbkcms/studentlife/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/studentlife/create-page', title: 'Create Page', type: 'link' },
					]
				},
			
				 {
					title: 'Campus life Clubs', type: 'sub', children: [
						{ path: '/adminhkbkcms/facility/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/facility/create-page', title: 'Create Page', type: 'link' },
					]
				}, 
			]
		},
		/*{
			title: 'About Us', icon: 'box', type: 'sub', active: false, children: [
				{
					title: 'Overview', icon: 'users', type: 'sub', active: false, children: [
						{ path: '/adminhkbkcms/aboutusoverview', title: 'Edit Overview', type: 'link' },
					]
				},
				 {
					title: 'Rankings Heading', type: 'sub', children: [
						{ path: '/adminhkbkcms/rankingheading/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/rankingheading/create-page', title: 'Create Page', type: 'link' },
					]
				}, 
				{
					title: 'Rankings Recognitions', type: 'sub', children: [
						{ path: '/adminhkbkcms/rankings/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/rankings/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Leadership', type: 'sub', children: [
						{ path: '/adminhkbkcms/leadership/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/leadership/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Committes', type: 'sub', children: [
						{ path: '/adminhkbkcms/committes/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/committes/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'IQAC Heading', type: 'sub', children: [
						{ path: '/adminhkbkcms/iqacheading/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/iqacheading/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'IQAC Sub Heading', type: 'sub', children: [
						{ path: '/adminhkbkcms/iqacsubheading/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/iqacsubheading/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'IQAC Content', type: 'sub', children: [
						{ path: '/adminhkbkcms/iqaccontent/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/iqaccontent/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Innovation Heading', type: 'sub', children: [
						{ path: '/adminhkbkcms/innovationheading/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/innovationheading/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Innovation Sub Heading', type: 'sub', children: [
						{ path: '/adminhkbkcms/innovationsubheading/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/innovationsubheading/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Innovation Content', type: 'sub', children: [
						{ path: '/adminhkbkcms/innovationcontent/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/innovationcontent/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Innovation Heading', type: 'sub', children: [
						{ path: '/adminhkbkcms/innovationheading/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/innovationheading/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Innovation Sub Heading', type: 'sub', children: [
						{ path: '/adminhkbkcms/innovationsubheading/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/innovationsubheading/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Innovation Content', type: 'sub', children: [
						{ path: '/adminhkbkcms/innovationcontent/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/innovationcontent/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{ path: '/adminhkbkcms/campus/create-page/', title: 'Facilities Overview', type: 'link' },
				{
					title: 'Facilities in Campus', type: 'sub', children: [
						{ path: '/adminhkbkcms/facilitiesoverview/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/facilitiesoverview/create-page', title: 'Create Page', type: 'link' },
					]
				},
			]
		},
		 {
			title: 'Academics', icon: 'box', type: 'sub', active: false, children: [
				{
					title: 'Academics Information', type: 'sub', children: [
						{ path: '/adminhkbkcms/academics/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/academics/create-page', title: 'Create Page', type: 'link' },
					]
				},
			]
		}, */
		{
			title: 'Admissions', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/admissions-overview/', title: 'Admissions Overview', type: 'link' },
				{ path: '/adminhkbkcms/how-to-apply/', title: 'Integrity Policy ', type: 'link' },
				{ path: '/adminhkbkcms/indian-students/', title: 'Tech Venture Bootcamp', type: 'link' },
				
				{ path: '/adminhkbkcms/international-students/', title: 'International Students', type: 'link' },
				{ path: '/adminhkbkcms/education-loan/', title: 'education-loan', type: 'link' },
				{ path: '/adminhkbkcms/scholarships/', title: 'Scholarships', type: 'link' },
			]
		},
	/* 	{
			title: 'Research & Innovation', icon: 'box', type: 'sub', active: false, children: [
				{
					title: 'Institute Industry Connect', type: 'sub', children: [
						{ path: '/adminhkbkcms/iic/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/iic/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{ path: '/adminhkbkcms/innovation', title: 'Innovation', type: 'link' },
				{
					title: 'Learning Resources', type: 'sub', children: [
						{ path: '/adminhkbkcms/learning-resources/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/learning-resources/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Learning Resources Uploads', type: 'sub', children: [
						{ path: '/adminhkbkcms/learning-resources-uploads/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/learning-resources-uploads/create-page', title: 'Create Page', type: 'link' },
					]
				},
			]
		}, */
		{
			title: 'Careers', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/careers/list-page', title: 'List Page', type: 'link' },
				{ path: '/adminhkbkcms/careers/create-page', title: 'Create Page', type: 'link' },
			]
		},
		{
			title: 'Faculty', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/faculty/list-page', title: 'List Page', type: 'link' },
				{ path: '/adminhkbkcms/faculty/create-page', title: 'Create Page', type: 'link' },
			]
		},
	/* 	{
			title: 'Lectures Workshops', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/lectures-workshops/list-page', title: 'List Page', type: 'link' },
				{ path: '/adminhkbkcms/lectures-workshops/create-page', title: 'Create Page', type: 'link' },
			]
		},
		{
			title: 'Student Innovations', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/student-innovations/list-page', title: 'List Page', type: 'link' },
				{ path: '/adminhkbkcms/student-innovations/create-page', title: 'Create Page', type: 'link' },
			]
		},
		{
			title: 'Calendar Of Events', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/coe/list-page', title: 'List Page', type: 'link' },
				{ path: '/adminhkbkcms/coe/create-page', title: 'Create Page', type: 'link' },
			]
		}, */
		{
			title: 'Admission Financial section ', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/research-hkbk/list-page', title: 'List Page', type: 'link' },
				{ path: '/adminhkbkcms/research-hkbk/create-page', title: 'Create Page', type: 'link' },
			]
		},
		/* {
			title: 'HR Development', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/hr-development/list-page', title: 'List Page', type: 'link' },
				{ path: '/adminhkbkcms/hr-development/create-page', title: 'Create Page', type: 'link' },
			]
		},
		{
			title: 'Summer Internships Heading', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/summer-internships-heading/list-page', title: 'List Page', type: 'link' },
				{ path: '/adminhkbkcms/summer-internships-heading/create-page', title: 'Create Page', type: 'link' },
			]
		},
		{
			title: 'Summer Internships', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/summer-internships/list-page', title: 'List Page', type: 'link' },
				{ path: '/adminhkbkcms/summer-internships/create-page', title: 'Create Page', type: 'link' },
			]
		},
		{
			title: 'Balance Sheet', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/balance-sheet/list-page', title: 'List Page', type: 'link' },
				{ path: '/adminhkbkcms/balance-sheet/create-page', title: 'Create Page', type: 'link' },
			]
		},
		{
			title: 'Industry Visits', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/industry-visits/list-page', title: 'List Page', type: 'link' },
				{ path: '/adminhkbkcms/industry-visits/create-page', title: 'Create Page', type: 'link' },
			]
		},
		{ path: '/adminhkbkcms/curriculum-enhancement', title: 'Curriculum Enhancement',icon: 'box', type: 'link' },
		{ path: '/adminhkbkcms/mentoring-advising', title: 'Mentoring Advising',icon: 'box', type: 'link' },
 */
		{
			title: 'Placements', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/placements-overview/create-page', title: 'Placements Overview', type: 'link' },
				{
					title: 'Placements Otherinfo', type: 'sub', children: [
						{ path: '/adminhkbkcms/placements-otherinfo/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/placements-otherinfo/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Students Placed', type: 'sub', children: [
						{ path: '/adminhkbkcms/students-placed/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/students-placed/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{ path: '/adminhkbkcms/training-development', title: 'Training Development', type: 'link' },
				{
					title: 'Training Vendors', type: 'sub', children: [
						{ path: '/adminhkbkcms/training-vendors/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/training-vendors/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Preplacement Training', type: 'sub', children: [
						{ path: '/adminhkbkcms/preplacement-training/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/preplacement-training/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Training Domains Heading', type: 'sub', children: [
						{ path: '/adminhkbkcms/training-domains-heading/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/training-domains-heading/create-page', title: 'Create Page', type: 'link' },
					]
				},
				{
					title: 'Training Domains Content', type: 'sub', children: [
						{ path: '/adminhkbkcms/training-domains-content/list-page', title: 'List Page', type: 'link' },
						{ path: '/adminhkbkcms/training-domains-content/create-page', title: 'Create Page', type: 'link' },
					]
				}
				
			]
		},
		/*{
			title: 'Sales', icon: 'dollar-sign', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/sales/orders', title: 'Orders', type: 'link' },
				{ path: '/adminhkbkcms/sales/transactions', title: 'Transactions', type: 'link' },
			]
		},
		{
			title: 'Coupons', icon: 'tag', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/coupons/list-coupons', title: 'List Coupons', type: 'link' },
				{ path: '/adminhkbkcms/coupons/create-coupons', title: 'Create Coupons', type: 'link' },
			]
		},*/
		
		
		/* {
			title: 'Courses', icon: 'clipboard', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/course/list-page', title: 'List Page', type: 'link' },
				{ path: '/adminhkbkcms/course/create-page', title: 'Create Page', type: 'link' },
			]
		}, */
		
		/*{
			title: 'Menus', icon: 'align-left', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/menus/list-menu', title: 'Menu Lists', type: 'link' },
				{ path: '/adminhkbkcms/menus/create-menu', title: 'Create Menu', type: 'link' },
			]
		}, */
		{
			title: 'Users', icon: 'user-plus', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/users/list-user', title: 'User List', type: 'link' },
				{ path: '/adminhkbkcms/users/create-user', title: 'Create User', type: 'link' },
			]
		},
		/* {
			title: 'Vendors', icon: 'users', type: 'sub', active: false, children: [
				{ path: '/adminhkbkcms/vendors/list-vendors', title: 'Vendor List', type: 'link' },
				{ path: '/adminhkbkcms/vendors/create-vendors', title: 'Create Vendor', type: 'link' },
			]
		}, */
		/*{
			title: 'Localization', icon: 'chrome', type: 'sub', children: [
				{ path: '/adminhkbkcms/localization/translations', title: 'Translations', type: 'link' },
				{ path: '/adminhkbkcms/localization/currency-rates', title: 'Currency Rates', type: 'link' },
				{ path: '/adminhkbkcms/localization/taxes', title: 'Taxes', type: 'link' },
			]
		},*/
		/* {
			title: 'Reports', path: '/adminhkbkcms/reports', icon: 'bar-chart', type: 'link', active: false
		},
		{
			title: 'Settings', icon: 'settings', type: 'sub', children: [
				{ path: '/adminhkbkcms/settings/profile', title: 'Profile', type: 'link' },
			]
		},
		{
			title: 'Invoice', path: '/adminhkbkcms/invoice', icon: 'archive', type: 'link', active: false
		},
		{
			title: 'Login',path: '/adminhkbkcms/auth/login', icon: 'log-in', type: 'link', active: false
		} */
	]
	// Array
	items = new BehaviorSubject<Menu[]>(this.MENUITEMS);


}
